import {Injectable} from '@angular/core';
import {DocumentModel} from '../models/document.model';
import {StateManagerService} from './state-manager.service';
import {CollectionsNames} from '../definitions/collections-names';
import {PersistDocumentService} from './persist-document.service';
import {DetaillineDTOModel} from '../models/detaillineDTO.model';
import {PatientDTOModel} from '../models/patientDTO.model';

@Injectable({
    providedIn: 'root'
})
export class HandleWardTransferService {

    constructor(private stateManagerService: StateManagerService,
                private collectionsNames: CollectionsNames,
                private persistDocumentService: PersistDocumentService) {
    }

    handleTransfer(document: DocumentModel, equipment: DetaillineDTOModel) {
        if (!this.transferAlreadyExists(document)) {
            document.documentType = 103;
            document.patient = new PatientDTOModel();
            document.patient.id = equipment.patientId;
            document.documentNumber = equipment.contractDocumentNumber;
            document.location = equipment.location;
            document.detailLines = [equipment];
            this.persistDocumentService.persistDocument(document);
        } else {
            document = this.stateManagerService.getCollection(this.collectionsNames.DOCUMENT)
                .find(doc => doc.documentType === 103 && doc.customer.id === document.customer.id && doc.site.id === document.site.id);
            document.detailLines.push(equipment);
            this.stateManagerService.upsert(this.collectionsNames.DOCUMENT, '$loki', document);
            this.stateManagerService.saveDatabase();
        }

    }

    private transferAlreadyExists(document: DocumentModel) {
        for (const doc of this.stateManagerService.getCollection(this.collectionsNames.DOCUMENT) as DocumentModel[]) {
            if (doc.documentType === 103 && doc.customer.id === document.customer.id && doc.site.id === document.site.id) {
                return true;
            }
        }
        return false;
    }
}
